module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("The River ")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "p0013-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter2#p0009-P-2333"
    }
  }, [_vm._v("From an Entry in a Journal")])])]), _vm._v(" "), _c('p', {
    staticClass: "txz",
    attrs: {
      "id": "p0013-02-1"
    }
  }, [_c('span', [_c('i', [_vm._v("I love coming to The River.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-2"
    }
  }, [_c('span', [_c('i', [_vm._v("The River is magical. It’s full of wonder and mystery. For thousands of years, The River has been carving its way through the Earth. As the water pours over the landscape, crashes against the banks, and cascades over the rocks, everything changes in its path. The terrain, the trees, even the wildlife-everything is shaped by The River. Everything in the canyon is at the mercy of The River.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-2256"
    }
  }, [_c('span', [_c('i', [_vm._v("The River is wild, free, and untamable. It’s foaming, twisting, and thundering. There are places where the water shoots down into crevices and canyons and creates this amazing thunder, and"), _c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_vm._v(" then there are places where the water settles into pools of complete calm. There are peaceful eddies where the riverbed is flat and the gradient is level, where the water mirrors the beautiful mountains surrounding the landscape. I love being with The River.")])])])]), _c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-01-1"
    }
  }, [_c('span', [_c('i', [_vm._v("The River is alive. The River is timeless, and it’s moving all over the world.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-01-2"
    }
  }, [_c('span', [_c('i', [_vm._v("I find myself drawn to The River. With its beauty and power, The River calls to me. The River can be known but not fully. Therein lies the mystery. The River has a voice, and I love the way it sounds. When I’m with The River, I just know it’s where I’m meant to be. It touches something deep inside my soul. It connects me to a bigger story in some indescribable way. I could spend countless hours just watching and listening.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-01-3"
    }
  }, [_c('span', [_c('i', [_vm._v("Since I was a small child, I’ve been fascinated and captivated by The River. It’s mesmerizing, really. The waters speak to me. Whether I’m skipping stones in a smooth eddy or feeling the thunder of a waterfall, when I’m with The River, I feel alive.")])])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-01-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_c('span', [_c('i', [_vm._v("I’ve experienced The River in many ways in my life. I haven’t always understood those experiences. What I will say is that The River ")])])]), _c('i', [_c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_vm._v("has allowed me to feel the deepest grief and given me the greatest joy.")])])]), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-1"
    }
  }, [_c('span', [_c('i', [_vm._v("I must confess, though, that there have been times when I’ve been angry with The River. It doesn’t seem to mind. I’ve been afraid of The River too, but somehow it keeps drawing me in. I am a small speck compared to its mighty waters, yet The River seems completely aware of me in a cosmic sort of way. Whether I was indifferent, aloof, or passionately bitter, The River never stopped calling me.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-2"
    }
  }, [_c('span', [_c('i', [_vm._v("I’ve watched The River from places high in the mountains where you couldn’t hear the water’s movement. The sight reminded me of a rich Monet hanging on the wall.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-3"
    }
  }, [_c('span', [_c('i', [_vm._v("I’ve sat on the banks and listened to the water flowing by gently, whispering to me like a mother soothing her child to sleep. I’ve waded into the calm eddies, where the cool water cascaded over my toes, massaging my feet and invigorating my skin.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-4"
    }
  }, [_c('span', [_c('i', [_vm._v("To float down the gentle rapids without a raft is like being carried in the strong arms of a father. Love pushes out any fear as you’re lifted through the canyon. You feel adventure and safety at the same time.")])])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_c('span', [_c('i', [_vm._v("I’ve skipped rocks on the mirrored water. I’ve")])])]), _c('i', [_c('a', {
    attrs: {
      "id": "pagexvi"
    }
  }, [_vm._v(" fly-fished in the deepest gorges, and better yet, I’ve rafted monstrous whitewater in breathtaking canyons all over the world. I’m still learning to trust The River, though, because I don’t know all that the waters have in store for me.")])])]), _c('a', {
    attrs: {
      "id": "pagexvi"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-1"
    }
  }, [_c('span', [_c('i', [_vm._v("But I do know this: I can’t live without The River. I’m still fearful yet drawn in. I’m in awe yet completely at home. Somehow, in the deepest places, I feel The River knows I’m here. I can’t explain it. I just know. It has never left me, and I will never leave it. I am captured and set free in this beautiful dance of hearts.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-2"
    }
  }, [_c('span', [_c('i', [_vm._v("I can tell you this from my journey: the more you experience The River, the more you want to stay close by. When you experience The River, you live.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "p0016-02-4"
    }
  }, [_c('span', [_c('i', [_c('br'), _vm._v("Gabriel Clarke      "), _c('br'), _vm._v("November 7, 1979")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecba1744","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 75
// module chunks = 0